import { DmaCaseBaseOfSimulation, MotionType, SafetyPredictionTrigger } from '@/api/ui/requests';
import { displayVesselClassDefinition } from '../formatting-utils';

export const motionAsTrigger = (motion: MotionType) => {
  switch (motion) {
    case MotionType.ROLL:
      return SafetyPredictionTrigger.MOTION_ROLL;
    case MotionType.PITCH:
      return SafetyPredictionTrigger.MOTION_PITCH;
    case MotionType.YAW:
      return SafetyPredictionTrigger.MOTION_YAW;
    case MotionType.SURGE:
      return SafetyPredictionTrigger.MOTION_SURGE;
    case MotionType.SWAY:
      return SafetyPredictionTrigger.MOTION_SWAY;
    case MotionType.HEAVE:
      return SafetyPredictionTrigger.MOTION_HEAVE;
    default:
      return undefined;
  }
};

export function basisOfSimulationVesselClassDefinition({
  vessel,
  customerParameters,
}: Pick<DmaCaseBaseOfSimulation, 'vessel' | 'customerParameters'>) {
  const customerVesselDefinition = customerParameters?.customerVesselDefinition;
  return {
    vesselType: customerVesselDefinition?.customerVesselType ?? vessel?.vesselType,
    vesselClassName: customerVesselDefinition?.customerVesselClass ?? vessel?.vesselClass?.name,
    vesselClassDefinition: customerVesselDefinition?.customerVesselDefinition ?? displayVesselClassDefinition(vessel?.vesselClass),
    customerVesselName: customerVesselDefinition?.customerVesselName ?? customerParameters?.vesselName,
  };
}
